export const PROVIDER_DETAILS = 'provider-details';